// extracted by mini-css-extract-plugin
module.exports = {"contents":"_e","sectionHeading":"af"};